// Shared host-based "Target" app resolution for the SSO admin drawers
// (Sign-in / SAML and Sync / SCIM). The Target field is read-only and
// derived from the current page's hostname, so a single source of truth
// for both drawers keeps the two in lock-step.

export const APP_NAME_CHOICES = [
  { value: 'safe+', label: 'SAFE+' },
  { value: 'aegix-aim', label: 'Aegix' },
  { value: 'dirs', label: 'DIR-S' },
];

// Host-based app-name resolution:
//   - subdomain contains "safe"        → safe+    (e.g. safe.aegix.global)
//   - apex domain is dirs.app / dirs.com → dirs   (e.g. sms.dirs.app)
//   - everything else (default)        → aegix-aim
export function deriveAppNameFromHost(host: string): string {
  const lc = host.toLowerCase();
  const hostNoPort = lc.split(':')[0] ?? '';
  const parts = hostNoPort.split('.').filter(Boolean);
  const subdomain = parts[0] ?? '';
  const apex =
    parts.length >= 2
      ? `${parts[parts.length - 2]}.${parts[parts.length - 1]}`
      : hostNoPort;
  if (subdomain.includes('safe')) return 'safe+';
  if (apex === 'dirs.app' || apex === 'dirs.com') return 'dirs';
  return 'aegix-aim';
}

export function appLabel(value: string): string {
  return APP_NAME_CHOICES.find((c) => c.value === value)?.label ?? value;
}
